import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {PatchAPICommand} from '@drl/core/api/commands/patch-api.command';
import {environment} from '@drl/env/environment';

export class ResetPasswordCommand<T> extends PatchAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.userApiUrl}/auth/reset-password`);
  }
}
